<template>
  <div class="head-page">
    <Header :title="$t('staking.title')" :showReturn="'0'" :icontype="2" :iconkey="'todo-list-o'" :iconurl="'staking-list'" />
    <div class="head-page-overflow" :style="isShowHeader ? '':'height: calc(100vh - 100px);'">
        <StakingItem :item="data" v-for="(data,index) in data" :key="index" />
    </div>
    <Footer @hide-header="hideHeader" v-show="!isShowHeader" />
  </div>
</template>
  
  <script>
import Header from "@/components/Header";
import Footer from "@/components/Footer/index.vue"
import { StakingItem } from './components/index'
export default {
  name: "MyStaking",
  components: { Header, StakingItem,Footer },
  data(){
    return {
      isShowHeader:true,
      data:null
    }
  },
  mounted(){
    this.getStakingProjects()
  },
  methods:{
    hideHeader(){
      this.isShowHeader = false
    },
    async getStakingProjects(){
      await this.$http({
        method: "post",
        url: "getStakingProjects"
      }).then((res) => {
        this.data = res.data.list;
      }); 
    }
  }
};
</script>

<style>
</style>
